import { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { AppLoader } from '../../../Components/common/AppLoader/AppLoader';
import { AwardCard } from '../../../Components/ui/AwardCard/AwardCard';
import { fetchAwardsForDisplay, mapAwardToCardProps } from '../../../api/awardsApi';
import './awardscertification.css';

const PAGE_SIZE = 3;

export const Awardscertification = () => {
  const [awards, setAwards] = useState([]);
  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      setLoading(true);
      setError('');
      try {
        const rows = await fetchAwardsForDisplay();
        if (cancelled) return;
        setAwards(rows.map(mapAwardToCardProps));
        setPage(0);
      } catch (err) {
        if (!cancelled) setError(err.message || 'Failed to load awards.');
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    load();
    return () => { cancelled = true; };
  }, []);

  const totalPages = Math.max(1, Math.ceil(awards.length / PAGE_SIZE));
  const visible = awards.slice(page * PAGE_SIZE, page * PAGE_SIZE + PAGE_SIZE);

  return (
    <section className="awards">
      <Container fluid className="awards__container">
        <h2 className="awards__title">Awards &amp; Certification</h2>
        <p className="awards__subtitle">
          Learn from leading doctors and specialists through focused, digestible video content.
        </p>

        {loading && (
          <AppLoader className="py-5" />
        )}

        {!loading && error && (
          <p className="text-center py-4 text-danger">{error}</p>
        )}

        {!loading && !error && (
          <>
            <Row className="awards__track g-4">
              {visible.length > 0 ? (
                visible.map((award) => (
                  <Col key={award.id} xs={12} md={6} lg={4}>
                    <AwardCard {...award} />
                  </Col>
                ))
              ) : (
                <Col xs={12}>
                  <p className="text-center py-4 awards__empty">No awards available yet.</p>
                </Col>
              )}
            </Row>

            {awards.length > PAGE_SIZE && (
              <div className="awards__nav">
                <button
                  type="button"
                  className="awards__nav-btn"
                  onClick={() => setPage((p) => Math.max(0, p - 1))}
                  disabled={page === 0}
                  aria-label="Previous"
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="15 18 9 12 15 6" />
                  </svg>
                </button>

                <button
                  type="button"
                  className={`awards__nav-btn ${page < totalPages - 1 ? 'awards__nav-btn--active' : ''}`}
                  onClick={() => setPage((p) => Math.min(totalPages - 1, p + 1))}
                  disabled={page >= totalPages - 1}
                  aria-label="Next"
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="9 18 15 12 9 6" />
                  </svg>
                </button>
              </div>
            )}
          </>
        )}
      </Container>
    </section>
  );
};
